import React from 'react'

//* Styles
import styles from './QuantityCell.module.scss'

const QuantityCell = ({ quantity, addProduct, removeProduct }) => {
  return (
    <div className={styles["quantity-cell"]}>
        {
            quantity <= 1 ? null :
            <div className={`${styles["quantity-box"]} ${styles["minus"]}`}>
                <ion-icon name="remove-circle-outline"
                    onClick={removeProduct}
                ></ion-icon>
            </div>
        }
        <div className={`${styles["quantity-box"]} ${styles["value"]}`}>{quantity}</div>
        <div className={`${styles["quantity-box"]} ${styles["add"]}`}>
            <ion-icon name="add-circle-outline"
                onClick={addProduct}
            ></ion-icon>
        </div>
    </div>
  )
}

export default QuantityCell